import { apiDelete, apiGet, apiPost, apiPut } from './api-service';
import { getUserDetails } from './session-service';

export async function getAll() {
    try {
        const response = await apiGet('core', `safe-work-method`);
        return response;
    } catch (e) { }
}

export async function getSafeWorkMethod(id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiGet('core', `safe-work-method/${id}`);
        return response.content;
    } catch (e) {
        return {};
    }
}


export async function addSafeWorkMethod(newDetails: any) {
    try {
        const response = await apiPost('core', `safe-work-method`, newDetails);
        return response;
    } catch (e) { }
}

export async function updateSafeWorkMethod(newDetails: any, id?: string) {
    try {
        if (!id) {
            id = getUserDetails().client_id;
        }
        const response = await apiPut('core', `safe-work-method/${id}`, newDetails);

        return response;
    } catch (e) { }
}

export async function removeSafeWorkMethod(id: any) {
    try {

        return await apiDelete('core', `safe-work-method/${id}`);
    } catch (e) { }
}